import { createSlice, combineReducers } from '@reduxjs/toolkit'
import { ProductList, ProductDetailsServerData } from '@lk/api'

import { loadProductList, loadProductDetails } from './product.actions'

export interface InitialListState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string
  data: ProductList
}

const initialListState: InitialListState = {
  status: 'idle',
  error: null,
  data: [],
}

export const listReducer = createSlice({
  name: 'productList',
  initialState: initialListState,
  reducers: {},
  extraReducers: {
    [loadProductList.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadProductList.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadProductList.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer

export interface InitialDetailsState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string
  byId: {
    [index: string]: ProductDetailsServerData
  }
}

const initialDetailsState: InitialDetailsState = {
  status: 'idle',
  error: null,
  byId: {},
}

export const detailsReducer = createSlice({
  name: 'productDetails',
  initialState: initialDetailsState,
  reducers: {},
  extraReducers: {
    [loadProductDetails.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadProductDetails.fulfilled.toString()]: (state, action) => {
      const { id, details } = action.payload

      state.status = 'loaded'
      state.byId[id] = details
    },
    [loadProductDetails.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer

export const productReducer = combineReducers({
  list: listReducer,
  details: detailsReducer,
})
